"use strict";

export default function ($stateProvider) {
  "ngInject";
  $stateProvider.state("reprocess", {
    url: "/reprocess",
    template: "<reprocess></reprocess>",
  });
}
